import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetSiteEncryptionDataKeyResult } from '~src/settings/security-settings/sections/credential-encryption/models/CredentialEncryptionModels';

export interface IGetSiteEncryptionDataKeyParams {}


export class GetSiteEncryptionDataKeyRequest extends Request<IGetSiteEncryptionDataKeyParams, IGetSiteEncryptionDataKeyResult> {
  constructor(params: IGetSiteEncryptionDataKeyParams) {
    super('getSiteEncryptionDataKey', params);
  }
}